import { postWithJson } from 'library/utils/serviceUtil'

/**
 * 坐席列表
 */
export const getSeatList = (params = {}) => {
	return postWithJson('/call/seat/list.np', params)
}

/**
 * 提交坐席
 */
export const addSeat = (params = {}) => {
	return postWithJson('/call/seat/add.np', params)
}


/**
 * 上传坐席
 */
export const importSeat = (params = {}) => {
	return postWithJson('/call/seat/import.np', params)
}

/**
 * 新增线路
 */
export const createCallAccount = (params = {}) => {
	return postWithJson('/call/account/add.np', params)
}

/**
 * 编辑线路
 */
export const modCallAccount = (params = {}) => {
	return postWithJson('/call/account/mod.np', params)
}

/**
 * 删除线路
 */
export const delCallAccount = (params = {}) => postWithJson('/call/account/del.np', params)

/**
 * 外呼线路列表
 */
export const getAccountList = (params = {}) => postWithJson('/call/account/list.np', params)
